import { MessageType } from "@regal-voice/shared-types";
import { EventEmitter } from "events";

const eventEmitter = new EventEmitter();

export function removeEventEmitterListener(eventName: string, callback: (...args: any[]) => void): void {
    eventEmitter.removeListener(String(eventName), callback);
}

export function removeAllEventEmitterListeners(eventName: string): void {
    eventEmitter.removeAllListeners(String(eventName));
}

/**
 * Sets up a listener on the event emitter and returns a function to unsubscribe it.
 */
export function addEventEmitterListener<T extends keyof MessageType, K extends keyof MessageType[T]>(
    namespace: T,
    event: K,
    callback: (data: MessageType[T][K], event: K) => void
): () => void {
    const eventName = String(event);
    removeEventEmitterListener(eventName, callback);
    eventEmitter.on(eventName, callback);
    return () => eventEmitter.off(eventName, callback);
}

export default eventEmitter;
